module.exports = __webpack_public_path__ + "img/djdz.e48afe45.svg";